<template>
    <div class="header">
        <div class="left">
            <div>
                <img src=@/assets/img/icon/u1365.png />
                <span v-text="barName"></span>
            </div>
            <p>
                <span>ID：</span>
                <span v-text="barId"></span>
                <span
                    style="margin-left:16px;"
                    v-show="$route.query.isSelf != 2"
                    >所在分组：</span
                >
                <span
                    v-text="groupName"
                    v-show="$route.query.isSelf != 2"
                ></span>
            </p>
        </div>
        <div class="right">
            <plugin-install-tip></plugin-install-tip>
            <a
                :href="$PAGE_API.other.downloadPlugin"
                target="_blank"
                class="default-btn"
                >下载远控插件</a
            >
            <a
                href="#"
                class="default-btn"
                v-show="$route.query.isSelf != 2"
                @click="setAssistCode"
                >设置远程授权</a
            >
            <hover-down v-show="$route.query.isSelf != 2">
                <div slot="hoverBtn" class="default-btn">
                    <span>更多</span>
                    <img src="@/assets/img/icon/u231.png" />
                </div>
                <div slot="down">
                    <div class="drop-row" @click="setDirectAndSpareModal">
                        <span>设置直连和备用远程</span>
                    </div>
                    <div v-if="hasEditBar">
                        <i class="line"></i>
                        <div class="drop-row" @click="editBarInfo()">
                            <span>修改网吧信息</span>
                        </div>
                        <div class="drop-row" @click="editBarPwd()">
                            <span>修改网吧密码</span>
                        </div>
                    </div>
                    <i class="line"></i>
                    <div class="drop-row" @click="addRouterRemote()">
                        <span>添加路由远程</span>
                    </div>
                </div>
            </hover-down>
            <a href="#" @click.prevent="refresh" class="default-btn">刷新</a>
        </div>
    </div>
</template>

<script>
import PluginInstallTip from '_sc/pluginInstallTip';
// 更多悬浮
import HoverDown from '_c/dropdown/hoverDown';

import { mapState } from 'vuex';

export default {
  name: 'barHeader',
  components: {
    HoverDown,
    PluginInstallTip
  },
  computed: {
    /* eslint-disable */
        ...mapState({
            barName: state => state.barDetails.barName,
            barId: state => state.barDetails.barId,
            groupName: state => state.barDetails.groupName,
            hasEditBar: state => state.user.userInfo.hasEditBar,
            hasRemote: state => state => state.user.userInfo.hasRemote
        })
    },
    methods: {
        setDirectAndSpareModal() {
            this.$emit("setDirectAndSpareModal");
        },
        addRouterRemote() {
            window.$modal.setRouterRemoteModal.show(
                { barId: this.$route.params.id },
                0
            );
        },
        setAssistCode() {
            window.$modal.assistCodeModal.show({
                barId: this.$route.params.id
            });
        },
        editBarInfo() {
            window.$modal.editBarInfo.show({
                type: 1,
                barId: this.$route.params.id
            });
        },
        editBarPwd() {
            window.$modal.editBarInfo.show({
                type: 2,
                barId: this.$route.params.id
            });
        },
        refresh() {
            let l = window.$msg.loading("请稍候...");
            setTimeout(() => {
                l.destroy()();
            }, 300);
            this.$emit("refresh");
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";

.header {
    padding-left: 30px;
    // padding-top: 20px;
    text-align: left;
    position: relative;
    z-index: 10;
}
.left {
    float: left;
    padding-top: 12px;
    p,
    div {
        line-height: 14px;
    }
    div {
        img {
            position: relative;
            top: 2px;
            margin-right: 8px;
        }
        span {
            font-weight: 650;
            font-size: 18px;
            color: #515151;
        }
    }
    p {
        padding-top: 10px;
        color: $gray-word;
    }
}
.right {
    float: right;
    padding-right: 20px;
    a {
        margin-left: 6px;
        // line-height: normal;
    }
    .default-btn {
        line-height: normal;
        text-align: center;
        cursor: pointer;
        img {
            margin-left: 12px;
        }
    }
    .default-btn:hover {
        background-color: #fff;
    }
}
</style>
